import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { CraClientFinalRoutingModule } from './cra-client-final-routing.module';
import { MonthlyListCraComponent } from './components/monthly-list-cra/monthly-list-cra.component';
import { ListCraClientFinalComponent } from './components/list-cra-client-final/list-cra-client-final.component';
import { ValiderCraClientFinalComponent } from './components/valider-cra-client-final/valider-cra-client-final.component';
import { DetailsCraCandidatComponent } from './components/details-cra-candidat/details-cra-candidat.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { WorkflowListComponent } from './components/workflow-list/workflow-list/workflow-list.component';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { AddWorkflowclientComponent } from './components/add-workflowclient/add-workflowclient/add-workflowclient.component';
import { AddWorkflowconsultantComponent } from './components/add-workflowconsultant/add-workflowconsultant/add-workflowconsultant.component';
import { ListTimesheetComponent } from './components/List-timesheet/list-timesheet/list-timesheet.component';
import { UpdateworkfloqclientComponent } from './components/updateworkfloqclient/updateworkfloqclient/updateworkfloqclient.component';
import { DetailworkflowclientComponent } from './components/detailworkflowclient/detailworkflowclient/detailworkflowclient.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CalendarModule } from 'primeng/calendar';
import localeFr from '@angular/common/locales/fr';


@NgModule({
  declarations: [
    MonthlyListCraComponent,
    ListCraClientFinalComponent,
    ValiderCraClientFinalComponent,
    DetailsCraCandidatComponent,
    WorkflowListComponent,
    AddWorkflowclientComponent,
    AddWorkflowconsultantComponent,
    ListTimesheetComponent,
    UpdateworkfloqclientComponent,
    DetailworkflowclientComponent,
  ],
  imports: [
    CommonModule,
    CraClientFinalRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSpinnerModule,
    NgSelectModule,
    PaginationModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    CalendarModule, 
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]

})
export class CraClientFinalModule {
  constructor() {
    registerLocaleData(localeFr);
  }
}
